module.exports = __webpack_public_path__ + "img/product2_11B984_occupation.90d387ba.png";